import type { GeneralProductionResponse, GeneralProductionRow, GeneralProductionUnit } from "../../../shared/general-production";
import { generalDate, generalQuantity, generalUnit } from "./general-production-format";
import { generalProductionActualBreakdown, generalProductionProgress } from "./general-production-model";

export function GeneralProductionProgress({ data, rows, units, date, shift }: {
  data: GeneralProductionResponse; rows: GeneralProductionRow[]; units: GeneralProductionUnit[]; date: string | null; shift: string;
}) {
  return <div className="genprod-progress-list">{units.map((unit) => {
    const value = generalProductionProgress(rows, unit, date, data.range.actualTo, data.actualsComplete, shift === "ALL");
    const breakdown = generalProductionActualBreakdown(rows, unit, date);
    const unknown = value.actual === null;
    return <section className="pack39-progress genprod-progress" key={unit} aria-label={`${date ? generalDate(date) : "Haftalık"} ${generalUnit[unit]} ilerleme özeti`}>
      <div className="pack39-progress-heading">
        <h2>{generalUnit[unit]}</h2>
        <p>{shift === "ALL" ? "Tüm vardiyalar" : shift}</p>
        {value.partial ? <p>Doğrulanmış ara toplam</p> : null}
      </div>
      <dl className="pack39-progress-values">
        <div className="pack39-progress-production"><dt>{date ? "Gün" : "Hafta"} üretim girişleri</dt><dd>{generalQuantity(value.actual)} <small>{generalUnit[unit]}</small></dd></div>
        <div><dt>{date ? "Gün" : "Hafta"} planı</dt><dd>{generalQuantity(value.target)} <small>{generalUnit[unit]}</small></dd></div>
        <div><dt>Hedefte kalan</dt><dd>{generalQuantity(value.remaining)} <small>{generalUnit[unit]}</small></dd></div>
      </dl>
      <dl className="genprod-actual-breakdown" aria-label={`${generalUnit[unit]} Mikro üretim kırılımı`}>
        <div><dt>Planı karşılayan</dt><dd>{generalQuantity(breakdown.PLAN_MATCHED)}</dd></div>
        <div><dt>Plan dışı</dt><dd>{generalQuantity(breakdown.UNPLANNED)}</dd></div>
        <div><dt>Teyit bekleyen</dt><dd>{generalQuantity(breakdown.REVIEW)}</dd></div>
      </dl>
      <div className="genprod-ratio">
        <span>Plan karşılama</span>
        <strong>{unknown || value.percentage === null ? "—" : `%${value.percentage}`}</strong>
        {!unknown && value.percentage !== null ? <progress max={100} value={value.percentage} aria-label={`${generalUnit[unit]} plan karşılama`} /> : null}
        <small>{shift !== "ALL" ? "Vardiya hedefi yok; kalan hesaplanmaz." : unknown ? "Üretim henüz doğrulanamadı." : value.partial ? "Hedef tahsisinde eksik veri var; kalan ve oran belirsiz." : "Doğrulanan hedefe göre"}</small>
      </div>
    </section>;
  })}</div>;
}
